export const erorrMessages = {
    ProcessingError: {
        HeaderMessage: "There was a problem with processing your transaction",
        Message: "The card has been declined, please check all the card details and try again."
    },
    IncorrectCVC: {
        HeaderMessage: "There was a problem with processing your transaction",
        Message: "The card has been declined, please check the CVC and expiration date and try again."
    },
    InsufficientFunds: {
        HeaderMessage: "There was a problem with processing your transaction",
        Message: "The card has been declined, please ensure the card details are correct and that enough funds are available and try again."
    },
    MaxValueError: {
        HeaderMessage: "You've exceeded the maximum donation amount allowed",
        Message: "Please try with a lower amount"
    },
    MaxBankAccountValueError: {
        HeaderMessage: "You've exceeded the maximum donation amount allowed",
        Message: "Bank account donations may not exceed $90,000. Please use credit card as a payment method for higher amounts."
    }
}